import { createAsyncThunk, isRejected } from '@reduxjs/toolkit';
import {
  actions as appStorageActions,
  utils as appStorageUtils,
  records as appStorageRecords,
} from '@saucelabs/sl-module-app-storage';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import types from './types';

type UpdateSettingsPayload = {
  groupId: number;
  originalValues: appStorageRecords.AppStorageGroupSettings;
  settingsName: string;
  updatedValues: appStorageRecords.AppStorageGroupSettings;
  warningText?: string;
}

const updateSettings = createAsyncThunk(
  types.UPDATE_SETTINGS,
  async (payload: UpdateSettingsPayload, { dispatch, rejectWithValue }) => {
    try {
      const {
        groupId,
        settingsName,
        updatedValues,
        warningText,
      } = payload;

      const response = await dispatch(appStorageActions.updateGroupSettings({
        groupId,
        settings: updatedValues,
      }));

      if (isRejected(response)) {
        const serverError = response.payload as appStorageUtils.SerializedApiError;
        throw serverError;
      }

      if (warningText) {
        dispatch(notificationActions.notifyWarning(
          `Successfully updated the ${settingsName} setting. ${warningText}`,
          undefined,
          true,
          undefined,
          true,
        ));
      } else {
        dispatch(notificationActions.notifySuccess(
          `Successfully updated the ${settingsName} setting`,
          undefined,
          false,
          undefined,
          true,
        ));
      }

      return response.payload;
    } catch (error) {
      let apiError: appStorageUtils.SerializedApiError;

      if (error instanceof Error) {
        apiError = appStorageUtils.handleApiError(error);
      } else {
        apiError = error as appStorageUtils.SerializedApiError;
      }

      const {
        code,
        detail,
        title,
      } = apiError.error;

      const {
        settingsName,
      } = payload;

      dispatch(notificationActions.notifyDanger(
        `Updating the ${settingsName} setting did not work as expected. Please refresh the page. ${detail}`,
        `${code} ${title}`,
        true,
        undefined,
        true,
      ));
      return rejectWithValue(apiError);
    }
  },
);

export default {
  updateSettings,
};
